<template>
    <b-row>
        <b-col lg="6">
            <div class="d-flex align-items-center mb-1">
                <div class="flex-grow-1">
                    HTMLエディタ
                </div>
                <div class="flex-shrink-1">
                    読込
                </div>
                <div class="flex-shrink-1">
                    <SelectHtml
                        v-model="listing_html_id"
                        size="xs"
                        @inputHtml="onInputHtml"
                        />
                </div>
            </div>
            <b-form-textarea
                :value="value"
                placeholder="商品の詳しい説明を書きましょう。"
                class="vh-50 vh-lg-80 mb-3"
                @input="onInput"
                @blur="onClickPreviewDescription"
                />
        </b-col>
        <b-col lg="6">
            プレビュー ※HTMLエディタのフォーカスを外すと更新
            <div class="border rounded overflow-y-hidden p-0 vh-50 vh-lg-80 mb-3">
                <iframe
                    :srcdoc="preview"
                    width="100%"
                    scrolling="yes"
                    frameborder="0"
                    style="
                    margin: 0;
                    padding: 0;
                    height: 100%;
                    "
                    />
            </div>
        </b-col>
    </b-row>
</template>

<script>
import { mapGetters } from 'vuex'
import SelectHtml from '@/components/SelectHtml.vue'

export default {
    components: {
        SelectHtml,
    },
    props: {
        value: {
            type: String,
            required: true,
            default() {
                return ''
            },
        },
    },
    data() {
        return {
            preview: '',
            listing_html_id: null,
        }
    },
    watch: {
        value: {
            handler(newVal, oldVal) {
                if (oldVal === undefined && newVal) {
                    this.onClickPreviewDescription()
                }
            },
            immediate: true,
        },
    },
    computed: {
        ...mapGetters([
        ])
    },
    mounted() {},
    methods: {
        async onClickPreviewDescription() {
            if (!this.value) {
                this.preview = null
                return
            }
            let res = await this.$store
                .dispatch('listing/preview_description', {
                    html: this.value,
                })
                .then((response) => {
                    return response.data
                })
                .catch((error) => {
                    return null
                })
            this.preview = res
        },
        onInput(v) {
            this.$emit('input', v)
        },
        onInputHtml(v) {
            this.listing_html_id = null
            this.$emit('input', v)
            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.$nextTick(() => {
                        this.onClickPreviewDescription()
                    })
                })
            })
        },
    },
}
</script>

<style lang="scss" scoped>
</style>

